
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import SexEnum from '@/enum/SexEnum'
import ArmEnum from '@/enum/ArmEnum'
import HandEnum from '@/enum/HandEnum'
import AgeEnum from '@/enum/AgeEnum'
import QualityEnum from '@/enum/QualityEnum'
import OfferCard from '@/components/offer/OfferCard'
import RouteService from '@/services/route.service'
import BannerView from '@/components/banner/BannerView'
import BANNER_TYPE from '@/enum/BannerType'
import Currency from '@/enum/currency'
import { roundPrice } from '@/utils'
import VueSocialSharing from 'vue-social-sharing'
import Vue from 'vue'

Vue.use(VueSocialSharing)

let LMap, LTileLayer, LPolygon, LTooltip, LMarker, LControlAttribution, VueEasyLightbox
if (process.client) {
  ({
    LMap,
    LTileLayer,
    LPolygon,
    LTooltip,
    LMarker,
    LControlAttribution,
  } = require('vue2-leaflet/dist/vue2-leaflet.min'))
  VueEasyLightbox = require('vue-easy-lightbox').default

  const { Icon } = require('leaflet')

  delete Icon.Default.prototype._getIconUrl
  Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  })
}

export default {
  name: 'offers-slug',
  components: {
    BannerView, OfferCard, LMap, LPolygon, LTileLayer, LTooltip, LMarker, LControlAttribution, VueEasyLightbox
  },

  head () {
    let { description, img, price } = this.offer
    const title = this.$t('pages.offerDetail.seo.title', { offerTitle: this.offer.title })
    return {
      title,
      meta: [
        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'twitter:title', name: 'twitter:title', content: title },

        { hid: 'description', name: 'description', content: description },
        { hid: 'og:description', property: 'og:description', content: description },
        { hid: 'twitter:description', name: 'twitter:description', content: description },

        { hid: 'og:image', property: 'og:image', content: img[0] ? img[0].url : '' },

        { hid: 'og:type', property: 'og:type', content: 'product' },
        { hid: 'product:price:amount', name: 'product:price:amount', content: price },
        { hid: 'product:price:currency', name: 'product:price:currency', content: this.currency }
      ],
      link: [
        { rel: 'preload', as: 'image', href: img[0] ? img[0].url : '' }
      ]
    }
  },

  jsonld () {
    const { title, description, img, price, publishedAt, size } = this.offer
    return {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      'name': title,
      'image': img && img.map(i => i.url),
      'description': description,
      ...(this.brand && {
        'brand': {
          '@type': 'Brand',
          'name': this.brand
        }
      }),
      ...(size && { 'size': size }),
      'offers': {
        '@type': 'Offer',
        'url': this.$config.baseUrl + this.$route.fullPath,
        'priceCurrency': this.offer.currency,
        'price': price,
        'itemCondition': 'https://schema.org/UsedCondition',
        'availability': 'https://schema.org/InStock',
        'shippingDetails': {
          '@type': "OfferShippingDetails",
          'shippingRate': {
            '@type': 'MonetaryAmount',
            'value': '0',
            'currency': this.offer.currency
          },
          'shippingDestination': [
            {
              '@type': 'DefinedRegion',
              'addressCountry': 'FR'
            }
          ]
        }
      },
      ...(publishedAt && { 'publishDate': this.$dayjs(publishedAt).format() })
    }
  },

  async asyncData ({ params, error, store, i18n }) {
    try {
      const { data } = await RouteService.getOfferWithSlug(params.slug)

      // We need to force reset the slug https://i18n.nuxtjs.org/lang-switcher/#dynamic-route-parameters
      const slugs = Object.fromEntries(i18n.locales.map(locale => [locale.code, { slug: params.slug }]))
      await store.dispatch('i18n/setRouteParams', slugs)

      return { offer: data.offer }
    } catch (e) {
      error({ statusCode: 404, message: 'Offer not found' })
    }
  },

  async fetch () {
    const promises = []
    if (this.offer.address !== null && this.offer.address.postalCode) {
      promises.push(this.retrievePolygon(this.offer.address.postalCode))
    }
    promises.push(this.retrieveSimilarOffers())

    await Promise.all(promises)
  },

  async created () {
    this.BANNER_TYPE = BANNER_TYPE
  },

  mounted () {
    this.trackView()
  },
  //   if (process.client) {
  //     this.$refs.map.mapObject.setView(this.center)
  //     this.$refs.mapMobile.mapObject.setView(this.center)
  //   }
  // },

  data () {
    return {
      offer: {},
      similarOffers: [],
      SexEnum,
      AgeEnum,
      ArmEnum,
      HandEnum,
      QualityEnum,
      visible: false,
      index: 0,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="https://osm.org/copyright" target="_blank">OpenStreetMap</a>',
      attributionLeaflet: '<a href="https://leafletjs.com/" target="_blank">Leaflet</a>',
      zoom: 11,
      center: [0, 0],
      markerLatLng: [0, 0],
      polygon: {
        latlngs: [],
        color: '#4e4f50'
      },
    }
  },

  computed: {
    ...mapGetters({
      user: 'user/getUser',
      offersLiked: 'user/getOffersLiked',
      isAuthenticated: 'auth/isAuthenticated'
    }),
    currency () {
      return Currency[this.offer.currency].symbol
    },
    currentUrl () {
      if (!process.client) return ''
      return window.location.href
    },
    retrieveHeartClass () {
      return this.isLiked ? 'fas' : 'far'
    },
    getOfferTittle () {
      return this.offer.title.length > 40 ? `${this.offer.title.substr(0, 40)}...` : this.offer.title
    },
    getOfferDescription () {
      if (!this.offer.description) return ''
      return this.offer.description.length > 150 ? `${this.offer.description.substr(0, 150)}...` : this.offer.description
    },
    getFirstImgSectionClass () {
      const { img } = this.offer
      if (!img) return ''
      if (img.length >= 3) {
        return 'col-sm-7'
      }
      if (img.length === 2) {
        return 'col-sm-6'
      }
      return ''
    },
    getSecondImgSectionClass () {
      const { img } = this.offer
      if (!img) return ''
      if (img.length >= 3) {
        return 'col-sm-5'
      }
      if (img.length === 2) {
        return 'col-sm-6'
      }
      return ''
    },
    homeDelivery () {
      return this.offer.homeDelivery ? this.$t('common.Yes') : this.$t('common.No')
    },
    contactBtnIsVisible () {
      return !!this.offer.userId && (!this.isAuthenticated || (this.user && this.user.id !== this.offer.userId))
    },
    callBtnIsVisible () {
      return (this.offer.seller && this.offer.seller.showTel) && !!this.offer.userId &&
        (!this.isAuthenticated || (this.user && this.user.id !== this.offer.userId))
    },
    displayedPrice () {
      const { price } = this.offer
      return price > 0 ? roundPrice(price) : 0
    },
    showLikeButton () {
      return this.isAuthenticated && this.offer.id
    },
    offerIsActive () {
      return this.offer && this.offer.status === 'active'
    },
    showEditOffer () {
      return this.isAuthenticated && this.user && this.offer.userId === this.user.id
    },
    isLiked () {
      if (!Array.isArray(this.offersLiked)) return false
      return this.offersLiked.includes(this.offer.id)
    },
    brand () {
      return this.offer.fullBrand ? this.offer.fullBrand.name : this.offer.brand
    },
    brandSlug () {
      return this.offer.fullBrand ? this.offer.fullBrand.slug : null
    },
    postalCode () {
      if (this.offer.address && this.offer.address.postalCode) {
        return this.offer.address.postalCode
      }
      return null
    },
    country () {
      if (this.offer.address && this.offer.address.addressCountry) {
        return this.offer.address.addressCountry.name
      }
      return ''
    },
    city () {
      if (this.offer.address && this.offer.address.city) {
        return this.offer.address.city
      }
      return null
    },
    addressType () {
      if (this.offer.address) {
        return this.offer.address.type
      }
      return null
    },
    addressCoords () {
      if (this.offer.address  && this.offer.address.lat && this.offer.address.lon) {
        return [this.offer.address.lat, this.offer.address.lon]
      }
      return [0,0]
    },
    addressCenter () {
      if (this.addressType === 'full_address') {
        return this.center
      }
      return this.addressCoords
    }
  },

  methods: {
    ...mapActions({
      gtmClick: 'gtm/clickItem',
    }),

    async retrieveSimilarOffers () {
      try {
        const { data } = await RouteService.getSimilarOffers(this.offer.id)
        this.similarOffers = data.offers
      } catch (e) {
        return false
      }
    },

    async retrievePolygon (postalCode) {
      const { data: _data } = await axios.get(`https://geo.api.gouv.fr/communes?codePostal=${postalCode}&fields=centre,contour,code,name,surface`, { withCredentials: false })
      const data = _data[0]
      this.center = data.centre.coordinates.reverse()
      this.markerLatLng = data.centre.coordinates
      const { type, coordinates } = data.contour
      this.polygon.latlngs = type === 'Polygon' ? [coordinates.map(obj => obj.map(o => o.reverse()))] : [coordinates.map(obj => obj.map(obj => obj.map(obj => obj.reverse())))]
      this.zoom = data.surface > 3000 ? 11 : 12 // TODO Maths
    },

    show (index) {
      this.index = index
      this.visible = true
    },

    handleHide () {
      this.visible = false
    },

    contactSeller () {
      this.$router.push(this.localeRoute({ name: 'offers-slug-message', params: { slug: this.$route.params.slug } }))
    },

    async toggleLike () {
      if (this.isLiked) {
        // UnLike
        try {
          await this.$store.dispatch('user/unLikeOffer', this.offer)
        } catch (ex) {
          /* continue regardless of error */
        }
      } else {
        // Like
        try {
          await this.$store.dispatch('user/likeOffer', this.offer)
        } catch (ex) {
          /* continue regardless of error */
        }
      }
    },

    editOffer () {
      this.$router.push(this.localePath({ name: 'account-offer-edit', query: { id: this.offer.id } }))
    },

    trackView () {
      if (!this.offer.id) return
      this.$store.dispatch('gtm/viewItem', this.offer)
    },

    async gtmImpression (isVisible, offer, index) {
      if (!isVisible) return
      await this.$store.dispatch('gtm/viewItemList', {
        item: offer,
        listId: 'similar_offers',
        list: 'Similar Offers',
        index,
      })
    }
  }
}
